import React from "react";
import vantaa from "../../assets/partners/vantaa.png";
import kemijarvi from "../../assets/partners/kemijarvi.png";
import janka from "../../assets/partners/janka.png";
import routa from "../../assets/partners/routa.png";
import rovaniemi from "../../assets/partners/rovaniemi.png";

// The one partner list for every page. `height` balances logos optically: thin line art needs more size.
const PARTNERS = [
  { name: "Vantaa", logo: vantaa, height: "h-14" },
  { name: "Kemijärvi", logo: kemijarvi, height: "h-12" },
  { name: "Jänkä", logo: janka, height: "h-12" },
  { name: "Routa", logo: routa, height: "h-14" },
  { name: "Rovaniemi", logo: rovaniemi, height: "h-12" },
];

export function PartnerStrip() {
  return (
    <section
      aria-labelledby="partner-strip-title"
      className="relative mt-[22px] mx-auto w-[calc(100%-2rem)] md:w-[calc(100%-240px)] max-w-[1400px] pb-10"
    >
      <div className="flex items-center gap-6">
        <span className="h-px flex-1 bg-[linear-gradient(to_right,transparent,rgba(255,255,255,0.18)_85%)]" />
        <h2
          id="partner-strip-title"
          className="text-xs leading-none uppercase tracking-[0.12em] text-white/55"
        >
          Our gym partners
        </h2>
        <span className="h-px flex-1 bg-[linear-gradient(to_left,transparent,rgba(255,255,255,0.18)_85%)]" />
      </div>
      <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-16 gap-y-6">
        {PARTNERS.map((p) => (
          <li key={p.name}>
            <img
              src={p.logo}
              alt={p.name}
              className={`${p.height} w-auto opacity-70 grayscale brightness-200 transition duration-300 hover:opacity-100 hover:grayscale-0 hover:brightness-100`}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}
